<div class="schedule-container">
<h2>{{ 'Booking Schedule Management' | translate }}</h2>
<p class="description">
  {{ '* Select the days and times you’re available — the calendar will update automatically.' | translate }}
</p>
  <div class="schedule-layout">
    <!-- Weekday Selection Section -->
    <div class="weekdays-panel">
      <div *ngFor="let day of weekDays" class="weekday-row">
        <mat-checkbox 
          [(ngModel)]="day.selected"
          (change)="onWeekDayChange(day)"
          color="primary"
          class="day-checkbox">
          {{ day.name }}
        </mat-checkbox>

      <div class="time-fields" *ngIf="day.selected">
        <label class="time-label">{{ 'From' | translate }}</label>
        <input type="time" class="time-input" [(ngModel)]="day.from" (change)="onWeekDayChange(day)" />

        <label class="time-label">{{ 'To' | translate }}</label>
        <input type="time" class="time-input" [(ngModel)]="day.to" (change)="onWeekDayChange(day)" />

        <label class="time-label">{{ 'Status' | translate }}</label>
        <select class="status-select" [(ngModel)]="day.status" (change)="onWeekDayChange(day)"
        [class.busy]="day.status==='Busy'"
        [class.available]="day.status==='Available'">

          <option *ngFor="let s of statusOptions" [value]="s">{{ s }}</option>
        </select>
      </div>

      </div>
    </div>

    <!-- Calendar Section -->
    <div class="calendar-panel">
      <mat-calendar [dateClass]="dateClass"></mat-calendar>
    </div>
  </div>
</div>
